import { PaginatedRequestParams, PaginatedResponse } from "../../../../common/pagination";
import { PaymentPartnerRepository } from "../../data";
import { PaymentPartner } from "../dtos";

export class PaymentPartnerService {

    private readonly repository;

    constructor() {
        this.repository = new PaymentPartnerRepository();
    }

    public search(req: PaginatedRequestParams): Promise<PaginatedResponse<PaymentPartner>> {
        return this.repository.search(req);
    }

    /**
     * Create or update partner instance
     * @param type
     * @param form
     */
    public createOrUpdate(form: PaymentPartner): Promise<PaymentPartner> {
        return this.repository.createOrUpdate(form);
    }

    /**
     * Delete partner by id
     * @param id
     */
    public delete(id: number): Promise<boolean> {
        return this.repository.delete(id);
    }

    /**
     * Delete all partners by ids
     * @param ids
     */
    public deleteAll(ids: number[]): Promise<boolean> {
        return this.repository.deleteAll(ids)
    }

    /**
     * Get partner details by id
     * @param id
     */
    public getDetails(id: number): Promise<PaymentPartner> {
        return this.repository.getDetails(id);
    }

    public activateAll(ids: number[]): Promise<boolean> {
        return this.repository.activateAll(ids);
    }

    public deactivateAll(ids: number[]): Promise<boolean> {
        return this.repository.deactivateAll(ids);
    }
}